export default __webpack_public_path__ + "static/media/frame-cards.b18192bc.png";